import { RoutePath } from '@core/types/route';

import { FooterLink } from '../types/footer';

export const MARTIAL_ART_FOOTER: FooterLink[] = [
  { href: RoutePath.KampfkunstTraining, text: 'Training' },
  { href: RoutePath.Kampfkunst, text: 'Kampfkunst' },
  { href: RoutePath.KampfkunstRanking, text: 'Graduierung' },
  { href: RoutePath.Selbstverteidigung, text: 'Selbstverteidigung' },
  { href: RoutePath.SolovevStyle, text: 'Solovev Style' },
  { href: RoutePath.KampfkunstFaq, text: 'FAQ' },
];

export const PEOPLE_FOOTER: FooterLink[] = [
  { text: 'Direktoren' },
  { href: RoutePath.AlexanderSolovev, text: 'Alexander Solovev' },
  { href: RoutePath.FalkoZander, text: 'Falko Zander' },
  { text: 'Deutschland, Berlin' },
  { href: RoutePath.ElenaZander, text: 'Elena Zander' },
  { href: RoutePath.DanielDonaczi, text: 'Daniel Donaczi' },
  { href: RoutePath.BenjaminKegler, text: 'Benjamin Kegler' },
  { href: RoutePath.MichaelProckl, text: 'Michael Prockl' },
  { text: 'Deutschland, Trier' },
  { href: RoutePath.DimitriErmisch, text: 'Dimitri Ermisch' },
  { href: RoutePath.WaldemarLotz, text: 'Waldemar Lotz' },
  { text: 'Schweiz, Solothurn' },
  { href: RoutePath.MartinLandolt, text: 'Martin Landolt' },
  { text: 'Frankreich, Lyon' },
  { href: RoutePath.EmmanuelBrun, text: 'Emmanuel Brun' },
];

export const OFFERINGS_FOOTER: FooterLink[] = [
  { href: RoutePath.KampfkunstInstructorProgram, text: 'Ausbilder werden' },
  { href: 'https://shop.systema-berlin.de/', text: 'Video Kurse' },
  { href: 'https://solovev-defense.myspreadshop.de/', text: 'Sportswear' },
];
